<div class="actions-toolbar surface-50 border-1 border-200 border-round-xl p-2 mb-3 flex flex-wrap align-items-center justify-content-between gap-2 shadow-xs">
    <div class="flex align-items-center gap-2 flex-wrap">
        <p-button label="Nuevo" icon="pi pi-plus" (onClick)="openForm()" [disabled]="!canCreate()" size="small" [rounded]="true"></p-button>

        <span class="toolbar-separator"></span>

        <p-button label="Editar" icon="pi pi-pencil" severity="secondary" [outlined]="true" (onClick)="openEditShow(false)"
            [disabled]="!canEdit()" size="small" [rounded]="true"></p-button>
        <p-button label="Eliminar" icon="pi pi-trash" severity="danger" [outlined]="true" (onClick)="confirmDelete()"
            [disabled]="!canDelete()" size="small" [rounded]="true"></p-button>

        <span class="toolbar-separator"></span>

        <p-button label="Orden" icon="pi pi-sort-alt" severity="help" [outlined]="true" (onClick)="openAssayAnaliteOrder()"
            [disabled]="!canOrder()" size="small" [rounded]="true"></p-button>
        <p-button *ngIf="showCloneButton()" label="Copiar" icon="pi pi-copy" severity="info" [outlined]="true"
            (onClick)="openTableCopyAssayAnalitesConfig()" [disabled]="!canCopy()" size="small" [rounded]="true"></p-button>
    </div>

    <div class="flex align-items-center px-2 text-500 text-xs" *ngIf="selectedAnalite">
        <i class="pi pi-check-circle text-primary mr-1"></i>
        <span>1 determinación seleccionada</span>
    </div>
</div>

<div class="table-container">
    <p-table *ngIf='!isLoading' [value]="tableData" selectionMode="single" [(selection)]="selectedAnalite"
        (onRowSelect)="onSelectionChanged()" (onRowUnselect)="onSelectionChanged()"
        (onRowDblClick)="cellDoubleClicked($event)" [scrollable]="true" scrollHeight="flex"
        styleClass="p-datatable-sm p-datatable-gridlines" [stripedRows]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Indice</th>
                <th>{{configService.selectedLanguage.analite}}</th>
                <th>Tipo</th>
                <th>SubGrupo</th>
                <th>{{configService.selectedLanguage.importReference}}</th>
                <th>Alias</th>
                <th>{{configService.selectedLanguage.calculated}}</th>
                <th>{{configService.selectedLanguage.active}}</th>
                <th>{{configService.selectedLanguage.cost}}</th>
            </tr>
            <tr>
                <th>
                    <p-columnFilter type="text" field="index"
                        [matchModeOptions]="MatchModeTextOptions"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="analite.name"
                        [matchModeOptions]="MatchModeTextOptions"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter field="cualitative" matchMode="in" [showMatchModes]="false" [showOperator]="false"
                        [showAddButton]="false">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiselect [(ngModel)]="value" [options]="cualitativeOptions" appendTo="body"
                                (onChange)="filter($event.value)" optionLabel="name" optionValue="value"
                                style="min-width: 14rem" [panelStyle]="{ minWidth: '16rem' }">
                                <ng-template let-option #item>
                                    <div class="flex items-center gap-2">
                                        <span>{{ option.name }}</span>
                                    </div>
                                </ng-template>
                            </p-multiselect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="analite_group_name"
                        [matchModeOptions]="MatchModeTextOptions"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="importReference"
                        [matchModeOptions]="MatchModeTextOptions"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="alias"
                        [matchModeOptions]="MatchModeTextOptions"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="boolean" field="calculated"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="boolean" field="active"></p-columnFilter>
                </th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData" (dblclick)="cellDoubleClicked({data: rowData})">
                <td>{{rowData.index}}</td>
                <td>{{rowData.analite.name}}</td>
                <td>
                    <span *ngIf="rowData.cualitative">Abc</span>
                    <span *ngIf="!rowData.cualitative">#123</span>
                </td>
                <td>{{rowData.analite_group_name}}</td>
                <td>{{rowData.importReference}}</td>
                <td>{{rowData.alias}}</td>
                <td>
                    <i class="pi"
                        [ngClass]="{'pi-check text-green-500': rowData.calculated, 'pi-times text-red-500': !rowData.calculated}"></i>
                </td>
                <td>
                    <i class="pi"
                        [ngClass]="{'pi-check text-green-500': rowData.active, 'pi-times text-red-500': !rowData.active}"></i>
                </td>
                <td>{{rowData.cost}}</td>
            </tr>
        </ng-template>
    </p-table>

    <div *ngIf='isLoading' class="flex flex-column align-items-center justify-content-center py-5">
        <p class="mb-3 text-700">Cargando determinaciones...</p>
        <p-progressSpinner styleClass="w-4rem h-4rem"></p-progressSpinner>
    </div>
</div>
